"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.json = {
    programs: [
        {
            id: 1,
            value: "Automotive Technician",
            name: "Automotive Technician"
        },
        {
            id: 2,
            value: "Computer Systems Technician",
            name: "Computer Systems Technician"
        },
        {
            id: 3,
            value: "Cosmetologist",
            name: "Cosmetologist"
        },
        {
            id: 4,
            value: "Dental Assistant",
            name: "Dental Assistant"
        },
        {
            id: 5,
            value: "Massage Therapy",
            name: "Massage Therapy"
        },
        {
            id: 6,
            value: "Medical Assistant",
            name: "Medical Assistant"
        },
        {
            id: 7,
            value: "Refrigeration & HVAC",
            name: "Refrigeration & HVAC"
        },
        {
            id: 8,
            value: "Nursing Assistant",
            name: "Nursing Assistant"
        },
        {
            id: 9,
            value: "Medical Billing and Coding",
            name: "Medical Billing and Coding"
        },
        {
            id: 10,
            value: "AUTOMOTIVE",
            name: "AUTOMOTIVE"
        },
        {
            id: 11,
            value: "Biomedical Equipment Technician",
            name: "Biomedical Equipment Technician"
        },
        {
            id: 12,
            value: "Business Office Admin",
            name: "Business Office Admin"
        },
        {
            id: 13,
            value: "Business Office Administration",
            name: "Business Office Administration"
        },
        {
            id: 14,
            value: "Computer Network Systems",
            name: "Computer Network Systems"
        },
        {
            id: 15,
            value: "General",
            name: "General"
        },
        {
            id: 16,
            value: "HVAC/R",
            name: "HVAC/R"
        },
        {
            id: 18,
            value: "Personal Trainer",
            name: "Personal Trainer"
        },
        {
            id: 19,
            value: "Pharmacy Technician",
            name: "Pharmacy Technician"
        },
        {
            id: 20,
            value: "Refrigeration and HVAC Technician",
            name: "Refrigeration and HVAC Technician"
        },
        {
            id: 21,
            value: "Cosmetology",
            name: "Cosmetology"
        },
        {
            id: 22,
            value: "Not Sure",
            name: "Not Sure"
        },
        {
            id: 23,
            value: "Undecided",
            name: "Undecided"
        },
        {
            id: 24,
            value: "Medical Billing and Coding Program",
            name: "Medical Billing and Coding Program"
        },
        {
            id: 25,
            value: "Electrical Technician",
            name: "Electrical Technician"
        },
        {
            id: 26,
            value: "Other",
            name: "Other"
        },
        {
            id: 27,
            value: "Automotive Technician Degree",
            name: "Automotive Technician Degree"
        },
        {
            id: 28,
            value: "Healthcare Administration: Medical Assistant",
            name: "Healthcare Administration: Medical Assistant"
        },
        {
            id: 29,
            value: "Healthcare Administration: Medical Billing & Coding",
            name: "Healthcare Administration: Medical Billing & Coding"
        }
    ],
    states: [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "District of Columbia", abbreviation: "DC" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Lousiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virginia", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" }
    ],
    tabs: [
        {
            step: "1",
            title: "Application"
        },
        {
            step: "2",
            title: "Education Disclosure"
        },
        {
            step: "3",
            title: "Code of Computing"
        },
        {
            step: "4",
            title: "Felony Acknowledgement Form"
        },
        {
            step: "5",
            title: "Identity Authentication Form"
        },
        {
            step: "6",
            title: "Online Education Disclosure"
        },
        {
            step: "7",
            title: "CPA Eligibility Form"
        },
        {
            step: "8",
            title: "Technical Standards Form"
        },
        {
            step: "9",
            title: "HIM Technical Standards"
        },
        {
            step: "10",
            title: "Transferability of Credits Form"
        },
        {
            step: "11",
            title: "Disclosure of Info Mississippi"
        },
        {
            step: "12",
            title: "Finish & Submit"
        }
    ],
    campuses: [
        {
            id: 1,
            name: "Colorado Springs",
            value: "Colorado Springs"
        },
        {
            id: 2,
            name: "Albuquerque",
            value: "Albuquerque"
        },
        {
            id: 3,
            name: "Grand Junction",
            value: "Grand Junction"
        },
        {
            id: 4,
            name: "Pueblo",
            value: "Pueblo"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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